import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Account } from 'auth/state'
import classNames from 'classnames'

interface PartnerCardProps {
    account: Account
    isSelected?: boolean
    onClick?: (accountSlug: string) => void
}

const PartnerCard = ({ account, isSelected, onClick }: PartnerCardProps) => {
    return (
        <div
            className={classNames('partner-card', { 'partner-card--selected': isSelected })}
            onClick={() => onClick?.(account.slug)}
            style={{ '--brand-color': account.style?.brandColor } as React.CSSProperties}
        >
            <div className="partner-card__logo">
                {account.style?.logoUrl ? (
                    <img src={account.style.logoUrl} alt="" className="partner-card__logo-img" />
                ) : (
                    <span className="partner-card__logo-fallback" />
                )}
            </div>
            <span className="partner-card__name">{account.name}</span>
            {isSelected && (
                <div className="partner-card__check" aria-hidden>
                    <FontAwesomeIcon icon={faCheck as IconProp} />
                </div>
            )}
        </div>
    )
}

export default PartnerCard
